import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { round } from '../../../../utilities';
import { IconType, SvgIcon } from '../../General/SvgIcon';

interface Props {
  value: number | null;
  percentage: number;
  currency: string;
}

function FreeDeliveryBox({ value, currency = '€', percentage }: Props) {
  const isFree = value === 0;

  if (value === null) {
    return null;
  }

  return (
    <ValueRow>
      <IconWrapper>
        {isFree ? (
          <FreeSvgIcon
            width={40}
            height={40}
            icon={IconType.freeDel}
            viewBox="0 0 48 48"
            alt="Doprava zdarma"
            title="Doprava zdarma"
          />
        ) : (
          <Circle percentage={percentage} />
        )}
      </IconWrapper>
      {!isFree ? (
        <Value>
          {__('Nakúpte ešte za')}{' '}
          <InfoPrice>{`${round(value, 2)} ${currency}`}</InfoPrice>{' '}
          {__('a dopravu máte zadarmo')}
        </Value>
      ) : (
        <Value>
          {__('Dopravu máte')}{' '}
          <InfoPrice color="#A5BBA2">{__('zadarmo')}</InfoPrice>
        </Value>
      )}
    </ValueRow>
  );
}

function Circle({ percentage }: { percentage: number }) {
  const size = 40;
  const strokeWidth = 4;
  const centerCircle = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((100 - percentage) / 100) * circumference;

  return (
    <CircleWrapper width={size} height={size}>
      <CircleOutside
        cx={centerCircle}
        cy={centerCircle}
        r={radius}
        stroke={'#EEEEEE'}
        strokeWidth={strokeWidth}
      />
      <CircleInside
        cx={centerCircle}
        cy={centerCircle}
        r={radius}
        stroke={'#A5BBA2'}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={progress}
        fill="transparent"
      />
    </CircleWrapper>
  );
}

const CircleWrapper = styled.svg`
  position: relative;
  text-align: center;
  fill: transparent;
  vertical-align: bottom;
  transform: rotate(-90deg);
`;

const CircleInside = styled.circle`
  position: relative;
  z-index: 1;
`;

const CircleOutside = styled.circle`
  position: relative;
  z-index: 0;
`;

const IconWrapper = styled('div')`
  display: inline-block;
  max-width: 20%;
`;

const FreeSvgIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.colors.success} !important;
`;

const InfoPrice = styled(FlexRowCenterVertical)<{
  borderBottom?: boolean;
  color: string;
}>`
  display: inline;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
`;

const ValueRow = styled(FlexRowCenterVertical)<{ borderBottom?: boolean }>`
  justify-content: flex-start !important;
  width: 100%;
  padding: ${rem(24)} ${rem(0)};
  justify-content: center;
  font-family: ${({ theme }) => theme.font.primary};
`;

const Value = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  // max-width: ${rem(240)};
  margin-left: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  text-align: left !important;
`;

export { FreeDeliveryBox };
